import { Body, Button, Flex } from '@teko/ds-desktop';
import { t } from 'i18n';

interface IViewMoreReviewsButtonProps {
  onClick: () => void;
  numberOfReviews: number;
}

export const ViewMoreReviewsButton: React.FC<IViewMoreReviewsButtonProps> = ({
  onClick,
  numberOfReviews,
}) => {
  return (
    <Flex align="center" justify="center" marginTop="s24" marginBottom="s16">
      <Button variant="link" onClick={onClick}>
        <Body level={1}>
          {t('Xem thêm {{numberOfReviews}} đánh giá', { numberOfReviews })}
        </Body>
      </Button>
    </Flex>
  );
};
